export default __webpack_public_path__ + "static/media/3.blur.2cf42874.jpeg";